import { classNames } from "../utils/classNames";

export default function Button({
  primary,
  secondary,
  gradient,
  children,
  onClick,
}: {
  primary?: boolean;
  secondary?: boolean;
  gradient?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className={classNames(
        "p-2 rounded-lg text-center cursor-pointer",
        primary && "bg-primary-500 text-white",
        secondary && "border border-primary-500 text-gray-600",
        gradient && "bg-gradient-to-r from-primary-500 to-pink-600 text-white",
      )}
    >
      {children}
    </button>
  );
}
